import { useMemo } from "react";
import { useBlockLayout, useSortBy, useTable } from "react-table";
import { IoTDeviceRegistration } from "src/api/iot/iot-types";
import { BaseButton } from "src/components";
import { calculateTableWidth } from "src/utils/common-util";
import { createIotConfigColumns } from "../../columns/IotConfigColumns";
import { useLocation } from "react-router-dom";
import { iotConfigUseTab, UnionIotConfigUseTab } from "src/api/iot/iot-config-type";

type Props = {
  list: IoTDeviceRegistration[];
  deleteAssignedDevice?: (registeredDeviceId: string) => void;
  type?: UnionIotConfigUseTab;
  onClose: () => void;
};

const AssignedIotList = ({ list, onClose, deleteAssignedDevice, type = iotConfigUseTab.CUSTOM_TAB }: Props) => {
  const location = useLocation();
  const columns = useMemo(() => {
    return createIotConfigColumns(location.pathname).slice(0, 5);
  }, [location.pathname]);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data: list,
    },
    useBlockLayout,
    useSortBy,
    (hooks) => {
      type === iotConfigUseTab.CUSTOM_TAB &&
        hooks.visibleColumns.push((columns: any) => [
          ...columns,
          {
            Header: "삭제",
            width: 50,
            Cell: ({ row }: any) => {
              return (
                <button
                  className="base-trash-btn color-gray border-none flex-center-start"
                  onClick={() => {
                    deleteAssignedDevice?.(row.original.id);
                  }}
                />
              );
            },
          },
        ]);
    },
  );

  return (
    <>
      <section className="base-abstract-modal__title flex-center-between ">
        <h1>IoT 연결기기</h1>
      </section>
      <section className="inner-tab-table mb20 contents-container__1200 px30">
        <div {...getTableProps()} className={`base-table sticky overflow-x-hidden`}>
          <div
            className="header" //
            // style={{ borderBottom: "1px solid #E0E0E0" }}
          >
            {headerGroups.map((headerGroup) => (
              <div {...headerGroup.getHeaderGroupProps()} className="base-table__tr">
                {headerGroup.headers.map((header) => {
                  return (
                    <div {...header.getHeaderProps()} className={`base-table__th cursor-unset flex-center-start`}>
                      {header.render("Header")}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
          <div {...getTableBodyProps()} className="body max-height500">
            {rows.map((row: any) => {
              prepareRow(row);
              return (
                <div {...row.getRowProps()} className={`base-table__tr`}>
                  {row.cells.map((cell: any) => {
                    return (
                      <div {...cell.getCellProps()} className={`base-table__td flex-center-start`}>
                        {cell.render("Cell")}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
          {rows.length === 0 && (
            <div className="base-table__tr table-cursor-unset" style={{ width: calculateTableWidth(createIotConfigColumns("").slice(0, 5)) }}>
              <div className="base-table__td w-100 text-center">
                <div className="w-100">
                  <span>등록된 데이터가 없습니다.</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      <section className="base-abstract-modal__btn-wrap">
        <BaseButton title="확인" onClick={() => onClose()} />
      </section>
    </>
  );
};

export default AssignedIotList;
